<template>
  <div id="app">
    <TopBar />
    <Sidebar />
    <ProfileSection />
    <ProjectSection />
    <NoteSection />
  </div>
</template>

<script>
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";

UIkit.use(Icons);

import ProfileSection from "../components/ProfileSection.vue";
import ProjectSection from "../components/ProjectSection.vue";
import NoteSection from "../components/NoteSection.vue";
import Sidebar from "../components/SideBar.vue";
import TopBar from "../components/TopBar.vue";

export default {
  name: "app",
  components: {
    Sidebar,
    TopBar,
    ProfileSection,
    ProjectSection,
    NoteSection,
  },
};
</script>

<style lang="less">
* {
  @import "../../custom/magic.less";
  margin: 0;
  font-family: "overpass", sans-serif;
  font-weight: 600;
  font-style: normal;
}
</style>
